import { ContainerParams, ContainerTypes } from '@/types/containerTypes';
import { Container } from './container';

export class Section extends Container {
  constructor(params: ContainerParams) {
    super(params);
    this.containerType = ContainerTypes.Section;
  }
}
